module.exports = __webpack_public_path__ + "img/wy4.3581a600.png";